export const navLinks = [
  { label: "首页", path: "/" },
  { label: "电影", path: "/category/movie" },
  { label: "电视剧", path: "/category/tv" },
  { label: "综艺", path: "/category/variety" },
  { label: "关于", path: "/about" },
];

export const categoryQuickLinks = [
  {
    type: "movie",
    label: "电影",
    desc: "聚焦最新国产原创电影，院线新作与独立佳作一站直达。",
    count: "1,286 部",
    icon: "ri-film-line",
    path: "/category/movie",
  },
  {
    type: "tv",
    label: "电视剧",
    desc: "年代、都市、悬疑、古装，热播自制剧集持续更新。",
    count: "864 部",
    icon: "ri-live-line",
    path: "/category/tv",
  },
  {
    type: "variety",
    label: "综艺",
    desc: "真人秀、音乐竞演、美食纪实，把快乐和治愈打包给你。",
    count: "512 档",
    icon: "ri-mic-line",
    path: "/category/variety",
  },
];

export const footerLinks = [
  { label: "首页", path: "/" },
  { label: "电影", path: "/category/movie" },
  { label: "电视剧", path: "/category/tv" },
  { label: "综艺", path: "/category/variety" },
  { label: "搜索", path: "/search" },
  { label: "关于我们", path: "/about" },
];

export const friendLinks = [
  { label: "国产影视观察", path: "/about" },
  { label: "原创剧本工坊", path: "/about" },
  { label: "光影评论社", path: "/about" },
  { label: "青年导演计划", path: "/about" },
];

export const socialLinks = [
  { label: "微博", icon: "ri-weibo-fill", handle: "@国产自拍" },
  { label: "微信", icon: "ri-wechat-fill", handle: "gczp_official" },
  { label: "哔哩哔哩", icon: "ri-bilibili-fill", handle: "国产自拍官方" },
  { label: "抖音", icon: "ri-tiktok-fill", handle: "gczp_film" },
];

export const teamMembers = [
  { name: "陈默", role: "内容主编", desc: "十年影视媒体从业经验，负责平台内容方向与选题策划。" },
  { name: "苏文", role: "运营负责人", desc: "关注国产原创内容生态，主导自制剧与综艺的专题运营。" },
  { name: "高远", role: "技术负责人", desc: "负责平台浏览体验与功能迭代，让找片变得更简单。" },
  { name: "何静", role: "社区经理", desc: "维护影迷社区氛围，收集用户反馈并推动内容优化。" },
];

export const faqs = [
  {
    q: "网站上的影视作品可以在线观看吗？",
    a: "本平台是国产自制影视作品的展示与资讯平台，目前所有内容均为前端演示，不提供真实播放与下载功能。",
  },
  {
    q: "收藏的作品会一直保存吗？",
    a: "收藏记录保存在你当前使用的浏览器本地，刷新或再次访问都会保留；清除浏览器数据后收藏会重置。",
  },
  {
    q: "如何找到特定年代或地区的作品？",
    a: "进入电影、电视剧或综艺分类页，使用「年代」和「地区」筛选，并结合「最新 / 热度 / 评分」排序即可快速定位。",
  },
  {
    q: "内容多久更新一次？",
    a: "平台每周更新最新的国产自制影视动态与专题推荐，热门内容会持续补充进推荐榜与分类列表。",
  },
];

export const siteStats = [
  { value: "2,600+", label: "在库影视作品" },
  { value: "18", label: "内容专题栏目" },
  { value: "120万", label: "月均浏览用户" },
  { value: "365", label: "天不间断更新" },
];